// Display-only labels & help copy for the SEO Content Opportunities dashboard.
// Backend field names, enums and stored values are NOT changed — these maps
// only affect what is rendered in the UI.

export const COLUMN_HELP = {
  title: {
    label: "Suggested Content Title",
    help: "The page or article title recommended by the system. Chutki can edit it before writing.",
  },
  keyword: {
    label: "Customer's Google Search",
    help: "The search phrase people enter into Google that created this opportunity.",
  },
  category: {
    label: "Content Type",
    help: "The type of content recommended, such as a customer question, comparison, routine, side effect or product guide.",
  },
  monthly: {
    label: "Monthly Searches",
    help: "Estimated number of Google searches per month in the selected country and language. This is an estimate, not an exact count.",
  },
  trend: {
    label: "12-Month Trend",
    help: "Shows whether interest in this search has increased, decreased or remained stable during the previous 12 months.",
  },
  gscImpressions: {
    label: "BlendSafe Google Impressions",
    help: "The number of times BlendSafe appeared in Google results for this search. Available after Google Search Console is connected.",
  },
  gscPosition: {
    label: "Average Google Position",
    help: "BlendSafe's average position in Google results for this search. A smaller number is better. Available after Google Search Console is connected.",
  },
  source: {
    label: "Data Source",
    help: "Where the keyword and performance information came from, such as DataForSEO or Google Search Console.",
  },
  score: {
    label: "Priority Score",
    help: "BlendSafe's internal 0–100 priority score based on demand, relevance, existing content and available performance data. A higher score means the opportunity should be reviewed sooner. This is not a Google ranking score.",
  },
  action: {
    label: "Recommended Next Step",
    help: "What Chutki should do with the opportunity: write a new article, create a main topic page, improve an existing page, verify a product or reject the opportunity.",
  },
};

export const ACTION_LABEL = {
  CREATE_ARTICLE: "Write New Article",
  CREATE_HUB: "Create Main Topic Page",
  IMPROVE_EXISTING: "Improve Existing Page",
  NEEDS_MAPPING: "Verify Brand or Product",
  REJECT: "Do Not Use",
};

export const ACTION_HELP = {
  CREATE_ARTICLE: "Write a manually researched article answering one specific customer question.",
  CREATE_HUB: "Build a comprehensive central page about a broad medication, ingredient or skincare topic. Related articles will link to this page.",
  IMPROVE_EXISTING: "BlendSafe already has a page covering this topic. Update that page instead of creating a duplicate.",
  NEEDS_MAPPING: "The system cannot yet confirm the product's ingredients or identity. Verify it before creating content.",
  REJECT: "The opportunity is irrelevant, invalid, duplicated or unsuitable for BlendSafe.",
};

export const SOURCE_LABEL = {
  "discovery_canary_kfk+serp": "DataForSEO + Google Results",
  dataforseo_search_volume: "DataForSEO Search Volume",
  gsc: "Google Search Console",
  manual: "Added Manually",
};

export const STATUS_LABEL = {
  discovered: "Discovered",
  selected: "Selected",
  researching: "Researching",
  writing: "Writing",
  evidence_review: "Evidence Review",
  seo_review: "SEO Review",
  ready_to_publish: "Ready to Publish",
  published: "Published",
  needs_update: "Needs Update",
  rejected: "Rejected",
  merged: "Merged",
};

export const GSC_DISCONNECTED_HELP =
  "Available after Google Search Console is connected";

export const GLOSSARY_NOTE =
  "Search volume and opportunity scores help prioritise content, but Chutki makes the final decision about what to write and publish.";

export function actionLabel(value) {
  return ACTION_LABEL[value] || value || "—";
}

export function actionHelp(value) {
  return ACTION_HELP[value] || null;
}

export function sourceLabel(value) {
  if (!value) return "—";
  return SOURCE_LABEL[value] || "Other Source";
}

export function statusLabel(value) {
  return STATUS_LABEL[value] || (value || "").replace(/_/g, " ") || "—";
}

export const GLOSSARY_SECTIONS = [
  { title: "Columns", items: Object.values(COLUMN_HELP) },
  {
    title: "Recommended next steps",
    items: Object.keys(ACTION_LABEL).map((k) => ({
      label: ACTION_LABEL[k],
      help: ACTION_HELP[k],
    })),
  },
];
